/* eslint-disable */
// ── Shared globals for Compaundia ─────────────────────────────────────────────
// Import this in every chart/page component that needs colours, formatters, or t()

// ── Colors ────────────────────────────────────────────────────────────────────
export const C = {
  cream:       "#F2F0E4",
  orange:      "#F28705",
  green:       "#5aad27",
  red:         "#E03E1A",
  blackCard:   "#0d0d0d",
  blackBorder: "#1c1c1c",
};

// ── i18n ──────────────────────────────────────────────────────────────────────
export const TR = {
  EN: {
    dashboard:"Dashboard", purchases:"Purchases", calendar:"Calendar",
    analytics:"Analytics", scenarios:"Scenarios", bitcoin:"Bitcoin",
    portfolio:"Portfolio", projection:"Projection", avgCalc:"Avg Calc",
    livePrice:"LIVE PRICE", enteredManually:"entered manually",
    breakEven:"BREAK-EVEN", above:"above", below:"below",
    totalInvested:"TOTAL INVESTED", portfolioValue:"PORTFOLIO VALUE",
    totalShares:"TOTAL SHARES", avgPrice:"AVG PRICE",
    pnl:"P&L", shares:"SHARES", invested:"INVESTED",
    value:"Value", price:"Price", date:"Date",
    bestTrade:"BEST TRADE", worstTrade:"WORST TRADE",
    winLoss:"WIN / LOSS", inProfit:"IN PROFIT", inLoss:"IN LOSS",
    portfolioValue2:"PORTFOLIO VALUE", mstrPrice:"PRICE · TRADES",
    cumulativePnl:"CUMULATIVE P&L", avgCostShare:"AVERAGE COST / SHARE",
    sharesAccumulated:"SHARES ACCUMULATED", targetPrice:"TARGET PRICE",
    tradesGrid:"TRADES", tradesInProfit:"TRADES IN PROFIT",
    tradesUnderwater:"TRADES UNDERWATER", pnlSplit:"P&L SPLIT",
    addTrade:"ADD TRADE", dollars:"Dollars ($)", clearAll:"CLEAR ALL",
    monthlyOverview:"MONTHLY OVERVIEW", monthlyBreakdown:"MONTHLY BREAKDOWN",
    investedByWeek:"INVESTED BY WEEK", parameters:"PARAMETERS",
    annualGrowth:"ANNUAL GROWTH RATE", startSellingAfter:"START SELLING AFTER",
    sellPctPerYear:"SELL % PER YEAR", projectionYears:"PROJECTION YEARS",
    portfolioAtEnd:"PORTFOLIO AT END", mstrPriceAtEnd:"PRICE AT END",
    sharesAtEnd:"SHARES AT END", totalSold:"TOTAL SOLD", sharesSold:"SHARES SOLD",
    howMuchAdd:"HOW MUCH WOULD YOU ADD?", avgCost:"AVG COST", buyPrice:"BUY PRICE",
    newAsset:"NEW ASSET", ticker:"TICKER", name:"NAME (optional)",
    createAsset:"CREATE ASSET", cancel:"Cancel",
    lightMode:"LIGHT MODE", darkMode:"DARK MODE",
    saving:"saving…", enterPrice:"ENTER PRICE",
    month:"Month", avgPriceCol:"Avg Price", noSelling:"NO SELLING",
    holding:"HOLDING", selling:"SELLING", today:"TODAY", phase:"Phase",
    weekOf:"WEEK OF", buyPriceLabel:"Buy price", purchasedLabel:"Purchased",
    importCsv:"IMPORT CSV", imported:"IMPORTED", dragOrClick:"Drag or click",
    records:"records", skipped:"skipped", replaceAll:"REPLACE ALL",
    addToExisting:"ADD TO EXISTING",
  },
  BG: {
    dashboard:"Dashboard", purchases:"Purchases", calendar:"Calendar",
    analytics:"Analytics", scenarios:"Scenarios", bitcoin:"Bitcoin",
    portfolio:"Portfolio", projection:"Projection", avgCalc:"Avg Price",
    livePrice:"LIVE PRICE", enteredManually:"entered manually",
    breakEven:"BREAK-EVEN", above:"above", below:"below",
    totalInvested:"TOTAL INVESTED", portfolioValue:"PORTFOLIO VALUE",
    totalShares:"TOTAL SHARES", avgPrice:"AVG PRICE",
    pnl:"P&L", shares:"SHARES", invested:"INVESTED",
    value:"Value", price:"Price", date:"Date",
    bestTrade:"BEST TRADE", worstTrade:"WORST TRADE",
    winLoss:"WIN / LOSS", inProfit:"IN PROFIT", inLoss:"IN LOSS",
    portfolioValue2:"PORTFOLIO VALUE", mstrPrice:"PRICE · TRADES",
    cumulativePnl:"CUMULATIVE P&L", avgCostShare:"AVERAGE COST / SHARE",
    sharesAccumulated:"SHARES ACCUMULATED", targetPrice:"TARGET PRICE",
    tradesGrid:"TRADES", tradesInProfit:"TRADES IN PROFIT",
    tradesUnderwater:"TRADES UNDERWATER", pnlSplit:"P&L SPLIT",
    addTrade:"ADD TRADE", dollars:"Dollars ($)", clearAll:"CLEAR ALL",
    monthlyOverview:"MONTHLY OVERVIEW", monthlyBreakdown:"MONTHLY BREAKDOWN",
    investedByWeek:"INVESTED BY WEEK", parameters:"PARAMETERS",
    annualGrowth:"ANNUAL GROWTH RATE", startSellingAfter:"START SELLING AFTER",
    sellPctPerYear:"SELL % PER YEAR", projectionYears:"PROJECTION YEARS",
    portfolioAtEnd:"PORTFOLIO AT END", mstrPriceAtEnd:"PRICE AT END",
    sharesAtEnd:"SHARES AT END", totalSold:"TOTAL SOLD", sharesSold:"SHARES SOLD",
    howMuchAdd:"HOW MUCH WOULD YOU ADD?", avgCost:"AVG COST", buyPrice:"BUY PRICE",
    newAsset:"NEW ASSET", ticker:"TICKER", name:"NAME (optional)",
    createAsset:"CREATE ASSET", cancel:"Cancel",
    lightMode:"LIGHT MODE", darkMode:"DARK MODE",
    saving:"saving…", enterPrice:"ENTER PRICE",
    month:"Month", avgPriceCol:"Avg Price", noSelling:"NO SELLING",
    holding:"HOLDING", selling:"SELLING", today:"TODAY", phase:"Phase",
    weekOf:"WEEK OF", buyPriceLabel:"Buy price", purchasedLabel:"Purchased",
    importCsv:"IMPORT CSV", imported:"IMPORTED", dragOrClick:"Drag or click",
    records:"records", skipped:"skipped", replaceAll:"REPLACE ALL",
    addToExisting:"ADD TO EXISTING",
  }
};

export let _lang = "EN";
export const setGlobalLang = (l) => { _lang = l; };
export const t = (key) => TR[_lang]?.[key] || TR.EN[key] || key;

// ── Formatters ────────────────────────────────────────────────────────────────
export const fmt$ = (v) => new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(v);
export const fmtPct = (v) => (v >= 0 ? "+" : "") + v.toFixed(2) + "%";
export const formatDate = (s) => { const [y, m, d] = s.split("-"); return `${d}.${m}.${y}`; };

// ── Responsive font helper ─────────────────────────────────────────────────────
export const responsiveFontSize = (value, baseSize = 20) => {
  const str = String(value);
  if (str.length <= 8)  return baseSize;
  if (str.length <= 10) return Math.round(baseSize * 0.85);
  if (str.length <= 12) return Math.round(baseSize * 0.72);
  return Math.round(baseSize * 0.62);
};
